import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e513e3fe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 bg-light p-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Rate Detail")
  ])
], -1))
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table table-striped table-sm" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "#"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Distance "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Per Unit Price"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Base Price"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Base Unit"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-start",
      scope: "col"
    }, "2nd Package "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-start",
      scope: "col"
    }, "3rd Package "),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-start",
      scope: "col"
    }, "4rt Package"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "City"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "user"),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-start"
    }, "Action")
  ])
], -1))
const _hoisted_8 = { class: "text-start" }
const _hoisted_9 = { class: "text-start" }
const _hoisted_10 = { class: "text-start" }
const _hoisted_11 = { class: "text-start" }
const _hoisted_12 = { class: "text-start" }
const _hoisted_13 = { class: "text-start" }
const _hoisted_14 = { class: "text-start" }
const _hoisted_15 = { class: "text-start" }
const _hoisted_16 = { class: "text-start" }
const _hoisted_17 = { class: "text-start" }
const _hoisted_18 = { class: "text-start" }
const _hoisted_19 = { class: "btn-group mr-2" }
const _hoisted_20 = { colspan: "11" }
const _hoisted_21 = { class: "overflow-hidden show" }
const _hoisted_22 = { class: "table table-sm" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-start"
}, "#", -1))
const _hoisted_24 = {
  scope: "col",
  class: "text-start"
}
const _hoisted_25 = {
  scope: "col",
  class: "text-start"
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-start"
}, "Range price ", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-start"
}, "Rate Price Type ", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-start"
}, "Start Price ", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-start"
}, "Relative Price ", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "text-start"
}, "Action", -1))
const _hoisted_31 = { class: "text-start" }
const _hoisted_32 = { class: "text-start" }
const _hoisted_33 = { class: "text-start" }
const _hoisted_34 = { class: "text-start" }
const _hoisted_35 = { class: "text-start" }
const _hoisted_36 = { class: "text-start" }
const _hoisted_37 = { class: "text-start" }
const _hoisted_38 = { class: "text-start" }
const _hoisted_39 = { class: "btn-group mr-2" }
const _hoisted_40 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("table", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_8, _toDisplayString($setup.rate.id), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString($setup.rate.distance_type), 1),
                _createElementVNode("td", _hoisted_10, _toDisplayString($setup.rate.per_unit_price), 1),
                _createElementVNode("td", _hoisted_11, _toDisplayString($setup.rate.base_price), 1),
                _createElementVNode("td", _hoisted_12, _toDisplayString($setup.rate.base_unit), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString($setup.rate.second_package_price), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString($setup.rate.third_package_price), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString($setup.rate.fourth_package_price), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString($setup.rate.city?.name), 1),
                _createElementVNode("td", _hoisted_17, _toDisplayString($setup.rate.user?.full_name), 1),
                _createElementVNode("td", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_router_link, {
                      to: `/rates/edit/${$setup.rate.id}`,
                      class: "btn btn-sm btn-secondary me-2"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Edit")
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _createElementVNode("a", {
                      class: "btn btn-sm btn-danger me-2",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.del($setup.rate.id)))
                    }, " Delete")
                  ])
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_router_link, {
                      to: `/rateranges/create/${$setup.rate.id}`,
                      class: "btn btn-sm btn-secondary"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Add Rate Range")
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _createElementVNode("table", _hoisted_22, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _hoisted_23,
                          _createElementVNode("th", _hoisted_24, "Start Range " + _toDisplayString($setup.rate.distance_type), 1),
                          _createElementVNode("th", _hoisted_25, "End Range " + _toDisplayString($setup.rate.distance_type), 1),
                          _hoisted_26,
                          _hoisted_27,
                          _hoisted_28,
                          _hoisted_29,
                          _hoisted_30
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.rate.rateranges, (raterange) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: raterange.id
                          }, [
                            _createElementVNode("td", _hoisted_31, _toDisplayString(raterange.id), 1),
                            _createElementVNode("td", _hoisted_32, _toDisplayString(raterange.start_range), 1),
                            _createElementVNode("td", _hoisted_33, _toDisplayString(raterange.end_range), 1),
                            _createElementVNode("td", _hoisted_34, _toDisplayString(raterange.range_price), 1),
                            _createElementVNode("td", _hoisted_35, _toDisplayString(raterange.rate_price_type), 1),
                            _createElementVNode("td", _hoisted_36, _toDisplayString(raterange.relative_start_price), 1),
                            _createElementVNode("td", _hoisted_37, _toDisplayString(raterange.relative_price), 1),
                            _createElementVNode("td", _hoisted_38, [
                              _createElementVNode("div", _hoisted_39, [
                                _createVNode(_component_router_link, {
                                  to: `/rateranges/${raterange.id}/edit`,
                                  class: "btn btn-sm btn-secondary me-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" Edit")
                                  ]),
                                  _: 2
                                }, 1032, ["to"]),
                                _createElementVNode("a", {
                                  class: "btn btn-sm btn-danger me-2",
                                  onClick: ($event: any) => ($setup.delraterange(raterange.id))
                                }, " Delete", 8, _hoisted_40)
                              ])
                            ])
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}